import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import IncidentUsersTable from './IncidentUsersTable';

const IncidentUsersTableContainer = props => (
  <Provider store={store}>
    <IncidentUsersTable {...props} />
  </Provider>
);

export default IncidentUsersTableContainer;
